module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container view"
  }, [_c('table', {
    staticClass: "section ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.quote.fixed_cost_items.items), function(item) {
    return _c('tr', {
      staticClass: "item"
    }, [_c('td', {
      staticClass: "description"
    }, [_c('div', {
      staticClass: "ui transparent input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.title = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_c('div', {
      staticClass: "ui transparent input"
    }, [_vm._v("\n            $"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.amount),
        expression: "item.amount",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(item.amount)
      },
      on: {
        "change": _vm.calcTotalAmount,
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.amount = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "controls"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "title": "Delete Item"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.confirmItemRemoval(item)
        }
      }
    }, [_c('i', {
      staticClass: "red remove link icon"
    })])])])
  }), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.quote.fixed_cost_items.amount)))])]), _vm._v(" "), _c('td', {
    staticClass: "controls"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": "Add Item"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "green plus link icon"
  })])])])], 2)]), _vm._v(" "), _c('modal-confirm', {
    attrs: {
      "payload": _vm.confirmPayload
    },
    on: {
      "confirm": _vm.remove
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          Fixed Cost Items\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "description"
  }, [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ba23e8e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/FixedCostItems.vue
// module id = 220
// module chunks = 2